import { Route, Routes } from 'react-router-dom';

import { MedicalReferralPage } from './ui';
import './styles/MedicalReferral.css';

export const MedicalReferral = () => {
  return (
    <Routes>
      <Route path='/*' element={<MedicalReferralPage />} />
    </Routes>
  );
};
